const airplay = require("../assets/icons/airplay.png");
const home = require("../assets/icons/home.png");
const left_arrow = require("../assets/icons/left-arrow.png");
const play = require("../assets/icons/play.png");
const play_button = require("../assets/icons/play-button.png");
const profile = require("../assets/icons/profile.png");
const right_arrow = require("../assets/icons/right-arrow.png");
const search = require("../assets/icons/search.png");
const star = require("../assets/icons/star.png");
const upload = require("../assets/icons/upload.png");

export default {
    airplay,
    home,
    left_arrow,
    play,
    play_button,
    profile,
    right_arrow,
    search,
    star,
    upload
}